<template>
  <v-container fluid>
    <v-row dense class="mb-2">
      <v-col>
        <SelectField 
          hide-details
          :label="$t('Часовой пояс')"
          :items="tz_items"
          v-model="schedule.timezone"
          :original_value="config.schedule.timezone"
        />
      </v-col>

    </v-row>
    <v-row dense>
      <v-col>
        <Intervals v-model="schedule.intervals" :original_value="config.schedule.intervals"/>
        <!-- <Intervals :loading="loading" :config="config.schedule.intervals" ref="form" @add="newInterval" @edit="editInterval" @remove="askRemoveInterval" @sorted="sortIntervals"/> -->
      </v-col>
      <v-col>
        <Calendar :config="schedule.intervals" />
      </v-col>
    </v-row>
    
  </v-container>
</template>

<script>
import Calendar from './Calendar.vue'
import settings_group_mixin from '../settings_group_mixin'
import Intervals from './Intervals'
import SelectField from '../../common/SelectField'

export default {
  mixins: [settings_group_mixin],
  data: () => ({

  }),
  computed: {
    schedule: {
      get() {
        return this.local_config.schedule || {}
      },
      set(v) {
        this.local_config.schedule = v
      }
    },
    tz_items(){
      let a = Intl.supportedValuesOf('timeZone');

      let items = []
      for (let i = 0; i < a.length; i++ ) {
        let zone = a[i]
        let offset = this.getTimezoneOffset(zone)
        if (!isNaN(offset)) {
          items.push({
            text: `${zone} (${this.timezoneOffsetStr(offset)})`,
            value: zone,
            offset: offset
          })
        }
      }

      return items.sort((a,b) => a.offset - b.offset)
    }
  },
  methods: {
    submit(){
      return JSON.parse(JSON.stringify(this.local_config.schedule))
    },
    validate(){},
    fillLen(str, len) {
      
      while (str.length < len) {
        str = `0${str}`
      }

      return str
    },
    getTimezoneOffset(timeZone, date = new Date()) {
      const tz = date.toLocaleString("en", {timeZone, timeStyle: "long"}).split(" ").slice(-1)[0];
      const dateString = date.toString();
      const offset = Date.parse(`${dateString} UTC`) - Date.parse(`${dateString} ${tz}`);
      
      // return UTC offset in millis
      return offset;
    },
    timezoneOffsetStr(offset) {
      const hours = Math.abs(Math.floor(offset / 3600000));
      const minutes = Math.floor((offset % 3600000) / 60000);
      // const seconds = Math.floor(((offset % 360000) % 60000) / 1000);
      return `${offset >= 0 ? '+' : '-'}${this.fillLen(`${hours}`, 2)}:${this.fillLen(`${minutes}`, 2)}`;
    }
  },
  components: {
    Calendar,
    Intervals,
    // IntervalEditor,
    SelectField
  }
}
</script>